import React, { useEffect, useState } from 'react';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import {
  DateRangeSelector,
  ENUM_DATE_RANGE,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import './styles.scss';
import { SlantArrowDownIcon } from 'cokitchen-icons';
import { apiService } from 'services/base.service';
import { formatNumber, getFullName, getSimpleDateFormat, getUserInitials } from 'utils/functions';
import { MemberListType } from 'models/member.model';

type Props = {
  setEditMode: (value: boolean) => void;
  singlePeople?: MemberListType;
};

const ViewDetails = ({ setEditMode, singlePeople }: Props) => {
  const [filter, setFilter] = useState(getDateRangeSelector(ENUM_DATE_RANGE.ALL)); // filter is yet to be used
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([] as any);
  const [percentage, setPercentage] = useState(0);
  useEffect(() => {
    if (singlePeople?.company_id) {
      fetchData();
      getPercentage();
    }
  }, [singlePeople, filter]);

  const getPercentage = () => {
    const percent = (Number(singlePeople?.amount_spent) / Number(singlePeople?.budget)) * 100;
    setPercentage(percent);
  };
  const fetchData = async () => {
    const { startDate: start_date, endDate: end_date } = filter;
    if (!singlePeople?.company_id) return;
    setLoading(true);
    try {
      const params = {
        start_date,
        end_date
      };
      const res = await apiService.get(`transactions/member/${singlePeople?.id}`, { params });
      setData(res?.data?.data.results);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='w-full member-details'>
      <div className='flex justify-between items-center mb-6'>
        <div className='flex gap-4'>
          <div className='w-[55px] h-[55px] rounded-full flex justify-center items-center bg-[#F4F1F1]'>
            <p className='text-[#725A5A] text-[20px] font-medium capitalize'>
              {getUserInitials(singlePeople?.user)}
            </p>
          </div>
          <div>
            <p className='text-[#2E3031] font-medium capitalize'>
              {getFullName(singlePeople?.user)}
            </p>
            <p className='text-[#6F7376] text-sm capitalize'>{singlePeople?.department.name}</p>
          </div>
        </div>
        <div
          className='w-[30px] h-[30px] rounded-full shadow flex justify-center items-center cursor-pointer'
          onClick={() => setEditMode(true)}>
          <EditIcon />
        </div>
      </div>
      <div className='flex justify-between items-center mb-4'>
        <p className='text-[#2E3031] text-sm'>Transaction details</p>
        <DateRangeSelector onChange={(v) => setFilter(v.date)} showCalendar isInput />
      </div>
      <div className='w-full border border-[#E5E6E6] rounded px-3 py-4 mb-6'>
        <div className='flex gap-3 items-center mb-4'>
          <p className='text-xs text-[#6F7376]'>Total Budget</p>
          <p className='text-[#2E3031] text-[18px] font-medium'>
            {singlePeople ? formatNumber(singlePeople?.budget) : '0.00'}
          </p>
        </div>
        <input
          type='range'
          className={`accent-[#E60A2B] w-full  disabled`}
          min='0'
          max='100'
          value={percentage}
          style={{
            backgroundSize: `${percentage}% 100%`
          }}
        />{' '}
        <div className='flex mt-2 justify-between'>
          <p className='text-sm text-[rgb(46,48,49)] font-medium'>
            &#8358;{singlePeople?.amount_spent}
            <span className='text-[#5E6164] font-normal'> spent so far</span>
          </p>
          <p className='text-[#5E6164] font-normal text-sm'>{percentage}%</p>
        </div>
      </div>
      <div className='w-full'>
        <p className='text-[#5E6164] text-sm mb-3'>Recent transactions</p>
        {loading ? (
          <div className='w-full mt-16 flex justify-center items-center'>
            <p className='text-sm'>Loading</p>
          </div>
        ) : data?.length === 0 ? (
          <div className='w-full mt-16 flex justify-center items-center'>
            <p className='text-sm'>This user has no transactions for the selected duration</p>
          </div>
        ) : (
          <>
            {data?.map((item: any, index: number) => (
              <div
                className='flex justify-between items-center pb-4 border-b border-b-[#EAEBEB] mt-[14px]'
                key={index}>
                <div className='flex gap-4 items-center'>
                  <div className='w-[30px] h-[30px] bg-[#F4F1F1] rounded-full flex justify-center items-center'>
                    <SlantArrowDownIcon className='w-5 h-4 slant-arrow' />
                  </div>
                  <p className='text-[#2E2E2E] text-sm font-medium'>{formatNumber(item.amount)}</p>
                </div>
                <p className='text-[#6F7376] text-xs'>{getSimpleDateFormat(item.created_at)}</p>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default ViewDetails;
